import { render, staticRenderFns } from "./userdrop.vue?vue&type=template&id=dc425af6"
import script from "./userdrop.vue?vue&type=script&lang=js"
export * from "./userdrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports